var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.title)?_c('div',[_c('p',{staticClass:"font-bold text-lg"},[_vm._v(" Thank you for your interest. ")]),_c('p',{staticClass:"mt-6"},[_vm._v(" But a High School diploma or High School equivalency is necessary in order to take this class. ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }